import React from 'react';
import styles from "./Loader.module.css";

export default function Loader({ silent }) {
  return (
    <div className={`${styles.loader} ${silent && styles.silent}`}>
      {!silent && (
        <img
          src="/assets/img/irish-logo.png"
          width="85"
          height="41"
          alt="Irish Funds Logo"
          style={{ objectFit: "contain" }}
        />
      )}
      <LoaderSvg />
    </div>
  );
}

function LoaderSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      stroke="#3FAE48"
      viewBox="0 0 44 44"
    >
      <g fill="none" fillRule="evenodd" strokeWidth="2">
        <circle cx="22" cy="22" r="1">
          <animate
            attributeName="r"
            begin="0s"
            calcMode="spline"
            dur="1.8s"
            keySplines="0.165, 0.84, 0.44, 1"
            keyTimes="0; 1"
            repeatCount="indefinite"
            values="1; 20"
          ></animate>
          <animate
            attributeName="stroke-opacity"
            begin="0s"
            calcMode="spline"
            dur="1.8s"
            keySplines="0.3, 0.61, 0.355, 1"
            keyTimes="0; 1"
            repeatCount="indefinite"
            values="1; 0"
          ></animate>
        </circle>
        <circle cx="22" cy="22" r="1">
          <animate
            attributeName="r"
            begin="-0.9s"
            calcMode="spline"
            dur="1.8s"
            keySplines="0.165, 0.84, 0.44, 1"
            keyTimes="0; 1"
            repeatCount="indefinite"
            values="1; 20"
          ></animate>
          <animate
            attributeName="stroke-opacity"
            begin="-0.9s"
            calcMode="spline"
            dur="1.8s"
            keySplines="0.3, 0.61, 0.355, 1"
            keyTimes="0; 1"
            repeatCount="indefinite"
            values="1; 0"
          ></animate>
        </circle>
      </g>
    </svg>
  );
}
